<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
        <div class="col-12"></div>
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <!-- ngx-datatable-filter -->
                        <fieldset class="form-group">
                            <div class="row align-items-end mt-0 pagination-body">
                                <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
                                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                                        [headerHeight]="40" [footerHeight]="40" rowHeight="auto" [limit]="limitRef"
                                        [rows]="rows" [externalPaging]="true" [count]="page.totalPages"
                                        [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                                </div>

                                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
                                    <div class="row-flex">
                                        
                                        <div class="col-flex-2 mb-1 position-relative">
                                            <input id="ngx-filter-ref"
                                                class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                                                type="text" placeholder="Search" #name
                                                (keydown.enter)="getTagsFilter(searchVal)" [(ngModel)]="searchVal" />
                                            <button class="btn search-btn glow position-absolute"
                                                (click)="getTagsFilter(searchVal)">
                                                <i class="ft-search text-white cursor-pointer"></i>
                                            </button>
                                        </div>
                                        <div class="col-flex-2 mb-1">
                                            <button class="btn btn-primary btn-block users-list-clear glow mb-0"
                                                (click)="resetFilter()">
                                                Reset
                                                <i class="ft-filter text-white cursor-pointer"></i>
                                            </button>
                                        </div>
                                        <div class="col-flex-2 mb-1"
                                            *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                                            <button type="reset"
                                                class="btn btn-primary btn-block users-list-clear glow mb-0"
                                                routerLink="/credentials/add" placement="top" ngbTooltip="Add New">
                                                +
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Credentials Guideline</button>
                                  </div>
                            </div>
                        </fieldset>
                        <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                            [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                            [offset]="page.offset" (page)="pageChangeData($event)">
                            <ngx-datatable-column name="Title" prop="title" [width]="60">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="d-flex align-items-center">
                                        <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                                            <div class="avatar-content">
                                                {{ row?.title | shortName }}
                                            </div>
                                        </div>
                                        <div class="cell-line-height cursor-pointer">
                                            <p class="font-medium-1 line-height-1 mb-0">
                                                {{ row?.title }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                          <ngx-datatable-column name="Access Level" prop="access_level" [width]="30">
                              <ng-template let-row="row" let-name="value" ngx-datatable-cell-template="ngx-datatable-cell-template">
                                  <div class="cell-line-height">
                                      {{row?.access_level}}
                                  </div>
                              </ng-template>
                          </ngx-datatable-column>
                            <ngx-datatable-column name="Primary Contact" prop="primary_contact" [width]="30">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="cell-line-height">
                                       {{row?.primary_contact}}
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Notes" prop="notes" [width]="70">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="cell-line-height">
                                        {{ row?.notes }}
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Actions" [width]="50"
                                *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <i class="ft-edit text-primary cursor-pointer mr-2"
                                        [routerLink]="['/credentials/edit', row._id]"></i>
                                    <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                                        (click)="ConfirmColor(row._id)"></i>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                        <!-- ngx-datatable-filter -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
</div>
